export type searchObject = {
  searchValue: string;
  searchParam: string;
  validation: (value: string) => boolean;
};

export type searchArray = Array<searchObject>;

export const generateNavigationString = (url: string, searchArray: searchArray) => {
  let search = url;
  searchArray.forEach((searchObject) => {
    const value = searchObject.searchValue;
    if (searchObject.validation(value)) {
      search += `?${searchObject.searchParam}=${value}`;
    }
  });
  return search;
};

export const CREATE_SEARCH_PARAM = 'create';
